import { ConsumerAssetSubtypeStepState } from './consumer-asset-subtype-step-interface'

export const createConsumerAssetSubtypeState =
  (): ConsumerAssetSubtypeStepState => ({
    assetSubtypeId: null,
    error: null,
    isWorkflowStepComplete: false,
    loading: false,
  })
